export const ARTICLE_REQUEST = 'ARTICLE_REQUEST';
export const ARTICLE_FAILURE = 'ARTICLE_FAILURE';
export const ARTICLE_SUCCESS = 'ARTICLE_SUCCESS';